import { render, staticRenderFns } from "./QueryModule.vue?vue&type=template&id=b39c54ca&scoped=true"
import script from "./QueryModule.vue?vue&type=script&lang=js"
export * from "./QueryModule.vue?vue&type=script&lang=js"
import style0 from "./QueryModule.vue?vue&type=style&index=0&id=b39c54ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39c54ca",
  null
  
)

export default component.exports